import Campaigns from "@/pages/performance-overview/Campaigns";
import { Col, Row } from "antd";
import WidgetCard from "./WidgetCard";

interface IProductCampaignsWidget {
    title?: string;
}
const ProductCampaignsWidget: React.FC<IProductCampaignsWidget> = ({
    title,
}) => {
    return (
        <WidgetCard className="my-4" bodyPaddingClass=" p-0 pb-0">
            <Row
                className="fs-5 fw-bold mb-3"
                justify="space-between"
                align="middle"
            >
                <Col className="ps-4 pt-4">
                <h5>
                  {title || "Campaigns"}
                </h5>
                </Col>
            </Row>

            <Row className="d-flex w-100" style={{ height: "400px" }}>
                <Campaigns />
            </Row>
        </WidgetCard>
    );
};

export default ProductCampaignsWidget;